var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0949 97.0949C15.8382 91.3516 23.6277 88.125 31.75 88.125H75.5C83.6223 88.125 91.4118 91.3516 97.1551 97.0949C102.898 102.838 106.125 110.628 106.125 118.75V131.25C106.125 134.357 103.607 136.875 100.5 136.875C97.3934 136.875 94.875 134.357 94.875 131.25V118.75C94.875 113.611 92.8337 108.683 89.2002 105.05C85.5667 101.416 80.6386 99.375 75.5 99.375H31.75C26.6114 99.375 21.6833 101.416 18.0498 105.05C14.4163 108.683 12.375 113.611 12.375 118.75V131.25C12.375 134.357 9.8566 136.875 6.75 136.875C3.6434 136.875 1.125 134.357 1.125 131.25V118.75C1.125 110.628 4.35155 102.838 10.0949 97.0949Z",
    fill: "#20A3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.625 24.375C42.9245 24.375 34.25 33.0495 34.25 43.75C34.25 54.4505 42.9245 63.125 53.625 63.125C64.3255 63.125 73 54.4505 73 43.75C73 33.0495 64.3255 24.375 53.625 24.375ZM23 43.75C23 26.8363 36.7113 13.125 53.625 13.125C70.5387 13.125 84.25 26.8363 84.25 43.75C84.25 60.6637 70.5387 74.375 53.625 74.375C36.7113 74.375 23 60.6637 23 43.75Z",
    fill: "#20A3BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.227 52.2725C150.424 54.4692 150.424 58.0308 148.227 60.2275L123.227 85.2275C121.031 87.4242 117.469 87.4242 115.273 85.2275L102.773 72.7275C100.576 70.5308 100.576 66.9692 102.773 64.7725C104.969 62.5758 108.531 62.5758 110.727 64.7725L119.25 73.295L140.273 52.2725C142.469 50.0758 146.031 50.0758 148.227 52.2725Z",
    fill: "#20A3BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.831e6d04670e8c9303b4d8ba216604d1.svg";
export { ForwardRef as ReactComponent };